export const DEFAULT_INTERVAL = 50;

export const BUSINESS_CARD_INTERVAL = 150;
